import { RequestBodyElement } from '@swagger-api/apidom-ns-openapi-3-1';

/**
 * @public
 */
class RequestBody extends RequestBodyElement {}
export default RequestBody;